/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import Slider from 'react-slick';

export function SlideShow(classname: string, imageList: any, properties: any) {
  return (
    <Slider className={classname} {...properties}>
      {imageList.map((image: any) => (
        <div className="each-slide" key={image.id}>
          <a href={image.url} target="_blank">
            <img src={image.img} alt={image.alt} />
            {MultiImageSlideOtherTag(image)}
          </a>
        </div>
      ))}
    </Slider>
  );
}

export function FlatShow(classname: string, imageList: any) {
  return (
    <ul className={classname}>
      {imageList.map((image: any) => (
        <li key={image.id}>
          <a href={image.siteUrl} target="_blank">
            <img src={`${process.env.REACT_APP_API_URL}/public${image.imageUrl}`} alt="" />
          </a>
        </li>
      ))}
    </ul>
  );
}

function MultiImageSlideOtherTag(image: any) {
  return (
    <ul>
      <li>{image.name}</li>
      <li>{image.writer}</li>
      <li>{image.price}</li>
    </ul>
  );
}
